
import { Component, Vue } from 'vue-property-decorator';

@Component<StudentPage>({})
export default class StudentPage extends Vue {}
